export default {
      id: "more-usage",
      viewBox: "0 0 8 14",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#more",
      toString: function () {
        return this.url;
      }
    }